import React from 'react';
import { ApolloClient, InMemoryCache } from 'apollo-boost';
import { SchemaLink } from 'apollo-link-schema';
import { addMockFunctionsToSchema, makeExecutableSchema } from 'graphql-tools';
import { merge } from 'lodash';
import { ApolloProvider } from 'react-apollo';
import { ApolloProvider as ApolloHooksProvider } from '@apollo/client';
import { Defaults, Resolvers, Types } from '../../schema';
import { fragmentMatcher } from './client-manager';
export var MockedApolloProvider = function (props) {
    var mocks = typeof props.serverResolvers === 'function' ? props.serverResolvers() : props.serverResolvers;
    var serverSchema = getMockedServerSchema({ mocks: mocks || {} });
    var serverSchemaLink = new SchemaLink({ schema: serverSchema });
    var cache = new InMemoryCache({ fragmentMatcher: fragmentMatcher });
    var client = new ApolloClient({
        link: serverSchemaLink,
        connectToDevTools: true,
        resolvers: Resolvers,
        cache: cache,
    });
    cache.writeData({ data: merge(Defaults, props.clientDefaults || {}) });
    return (React.createElement(ApolloProvider, { client: client },
        React.createElement(ApolloHooksProvider, { client: client }, props.children)));
};
function getMockedServerSchema(options) {
    var schema = makeExecutableSchema({
        typeDefs: Types,
        resolverValidationOptions: { requireResolversForResolveType: false },
    });
    addMockFunctionsToSchema({ schema: schema, mocks: options.mocks, preserveResolvers: true });
    return schema;
}
//# sourceMappingURL=mocked-provider.js.map